import React from 'react'
import {FaHeartbeat} from 'react-icons/fa'

interface CardCategoryProps {
  label: string
  count: number | undefined | null
  icon?: React.ReactNode
  onClick?: () => void
  className?: string
}

// For initial header of cards row

const CardCategory: React.FC<CardCategoryProps> = ({
  label,
  count,
  icon = <FaHeartbeat />,
  onClick,
  className = '',
}) => (
  <div
    className={`custom-card category-card text-white rounded-4 text-center py-4 d-flex flex-column justify-content-center align-items-center ${className}`}
    onClick={onClick}
  >
    {icon && (
      <div className='text-white' style={{fontSize: '28px'}}>
        {icon}
      </div>
    )}
    <h4 className='text-white fw-semibold small fs-6 mt-2'>{label}</h4>
    <span className='fs-5 fw-bold'>{(count ?? 0).toString().padStart(2, '0')}</span>
  </div>
)

export default CardCategory
